/**
 * Styled components for Report Sidebar
 */

import styled from 'styled-components'
import { Layout } from 'antd'
import { MEDIA, TYPOGRAPHY, FONT_WEIGHT } from '../../../../../styles/theme'

const { Sider } = Layout

export const StyledSider = styled(Sider)`
  background: var(--color-bg-elevated) !important;
  border-left: 1px solid var(--color-border) !important;
  height: 100% !important;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  flex-shrink: 0 !important;

  &.ant-layout-sider-collapsed {
    width: 0 !important;
    min-width: 0 !important;
    max-width: 0 !important;
    overflow: hidden !important;
    position: relative !important;
  }

  &:not(.ant-layout-sider-collapsed) {
    ${MEDIA.mobile} {
      position: fixed !important;
      top: 64px !important;
      right: 0 !important;
      bottom: 0 !important;
      left: 0 !important;
      width: 100% !important;
      max-width: 100% !important;
      z-index: 999 !important;
      border-left: none !important;
    }
  }
`

export const SidebarContent = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  max-width: 100%;
  overflow: hidden;
`

export const StickyFilterBar = styled.div<{ $hasActiveFilters?: boolean }>`
  flex-shrink: 0;
  padding: 12px 16px;
  background: var(--color-bg-elevated);
  border-bottom: 1px solid var(--color-border);
  z-index: 10;
`

export const SidebarBody = styled.div`
  flex: 1;
  padding: 16px;
  padding-bottom: 100px;
  box-sizing: border-box;
  max-width: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  ${MEDIA.mobile} {
    padding: 16px;
    padding-bottom: 100px;
  }
`

export const StickyExportBar = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  background: linear-gradient(to top, var(--color-bg-elevated) 70%, transparent);
  pointer-events: none;
  z-index: 10;
`

export const ExportButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 14px 24px;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: auto;
  box-shadow:
    0 4px 16px rgba(99, 102, 241, 0.3),
    0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-2px);
    box-shadow:
      0 8px 24px rgba(99, 102, 241, 0.4),
      0 4px 8px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(99, 102, 241, 0.3);
  }
`

export const ExportButtonIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
`

export const ExportButtonText = styled.span`
  font-size: ${TYPOGRAPHY.body.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  color: white;
  letter-spacing: 0.3px;
`

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  color: var(--color-text-secondary);
`
